/* ===========================================================================
   PHP CHIMERA LAUNCH COUNTDOWN  —  chimera-popup.js

   Site-wide popup counting down to the Chimera launch on 16 October 2026.
   Replaces the Labor Day popup (labordaypopup.js).

   INSTALL
     1. Online Store > Themes > ... > Edit code > Assets > Add a new asset
        > Upload this file.
        NOTE: Shopify strips hyphens from uploaded filenames, so this will
        land as `chimerapopup.js`. Reference THAT name in the Liquid below.
     2. Replace the Labor Day Custom Liquid section's contents with:

          <div id="ph-chimera"></div>
          <script src="{{ 'chimerapopup.js' | asset_url }}" defer></script>

        Put the section in the Header group so it renders on every page.
        (The Labor Day one ended up in the Home page template, which is why
        it only appeared on the home page.)

   IT TURNS ITSELF OFF
     LAUNCH_AT below is both the countdown target and the cut-off. Once the
     launch moment passes the script returns immediately and renders nothing,
     so it can't sit there counting down to a date that's already gone.
     You'll want a different message from 16 Oct onwards anyway.

   SNOOZE, NOT ONCE-FOREVER
     This runs for weeks, not a long weekend, so dismissing it hides it for
     SNOOZE_DAYS rather than for good. Someone who says no in September still
     gets a reminder as launch gets close.
   =========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------- settings */
  // Midnight as 16 October begins, Eastern (EDT, UTC-4).
  var LAUNCH_AT   = Date.parse('2026-10-16T04:00:00Z');
  var STORAGE     = 'ph-chimera-countdown';
  var SNOOZE_DAYS = 7;
  var DELAY_MS    = 4000;

  var LEARN_LINK  = '/pages/chimera';
  var NOTIFY_LINK = '/products/chimera-6l-power-stroke-tuner';

  /* --------------------------------------------------------------- guards */
  if (Date.now() >= LAUNCH_AT) { return; }      // launched — needs a new message
  if (window.__phChimera) { return; }
  window.__phChimera = 1;

  // Don't interrupt someone already reading the Chimera page or checking out.
  var path = (window.location.pathname || '').toLowerCase();
  if (path.indexOf('/pages/chimera') === 0) { return; }
  if (path.indexOf('/products/chimera') === 0) { return; }
  if (/^\/(cart|checkout|checkouts|orders|account|challenge|password)/.test(path)) { return; }

  function snoozedUntil() {
    try {
      var v = window.localStorage.getItem(STORAGE);
      return v ? parseInt(v, 10) : 0;
    } catch (e) { return 0; }
  }
  function snooze() {
    try {
      window.localStorage.setItem(STORAGE, String(Date.now() + SNOOZE_DAYS * 864e5));
    } catch (e) {}
  }
  if (Date.now() < snoozedUntil()) { return; }

  /* --------------------------------------------------------------- styles */
  var css = ''
    + '.phcx{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;'
    +   'justify-content:center;padding:20px;background:rgba(0,0,0,.75);opacity:0;'
    +   'transition:opacity .25s ease}'
    + '.phcx.is-open{opacity:1}'
    + '.phcx__card{position:relative;width:100%;max-width:560px;max-height:calc(100vh - 40px);'
    +   'overflow-y:auto;border-radius:12px;background:#0e0e0e;color:#fff;text-align:center;'
    +   'box-shadow:0 24px 60px rgba(0,0,0,.6);transform:translateY(12px) scale(.98);'
    +   'transition:transform .25s ease;font-family:inherit}'
    + '.phcx.is-open .phcx__card{transform:none}'
    /* Typographic header. The product artwork is a tall white graphic with the
       logo in the middle third, so any wide crop of it cuts through the lion.
       Type reads better here and drops an asset dependency. */
    + '.phcx__head{padding:30px 30px 4px;border-bottom:1px solid #1e1e1e}'
    + '.phcx__mark{font-size:38px;line-height:1;font-weight:800;letter-spacing:.18em;'
    +   'text-indent:.18em;margin:0;color:#fff}'
    + '.phcx__sub{margin:10px 0 22px;font-size:12px;letter-spacing:.22em;text-indent:.22em;'
    +   'text-transform:uppercase;color:#8a8a8a;font-weight:600}'
    + '.phcx__body{padding:22px 30px 28px}'
    + '.phcx__eyebrow{font-size:12px;letter-spacing:.16em;text-transform:uppercase;'
    +   'font-weight:700;color:#d61f26;margin:0 0 14px}'
    + '.phcx__copy{font-size:15px;line-height:1.55;color:#bdbdbd;margin:0 0 22px}'
    /* countdown */
    + '.phcx__clock{display:flex;justify-content:center;gap:10px;margin:0 0 22px}'
    + '.phcx__unit{flex:1 1 0;max-width:96px;background:#1b1b1b;border:1px solid #2c2c2c;'
    +   'border-radius:8px;padding:12px 4px}'
    + '.phcx__num{font-size:30px;line-height:1;font-weight:800;font-variant-numeric:tabular-nums;'
    +   'letter-spacing:-.02em;color:#fff}'
    + '.phcx__lbl{margin-top:6px;font-size:10px;letter-spacing:.12em;text-transform:uppercase;'
    +   'color:#8a8a8a;font-weight:600}'
    + '.phcx__date{font-size:13px;color:#8a8a8a;margin:0 0 22px}'
    /* actions */
    + '.phcx__cta{display:block;background:#d61f26;color:#fff;text-decoration:none;font-weight:700;'
    +   'font-size:16px;padding:14px 24px;border-radius:6px;transition:background .15s ease}'
    + '.phcx__cta:hover{background:#b8181f;color:#fff}'
    + '.phcx__alt{display:block;margin-top:12px;color:#cfcfcf;font-size:14px;text-decoration:none;'
    +   'border:1px solid #3a3a3a;border-radius:6px;padding:12px 24px;transition:border-color .15s ease}'
    + '.phcx__alt:hover{border-color:#6a6a6a;color:#fff}'
    + '.phcx__no{display:block;width:100%;margin-top:14px;background:none;border:0;padding:0;'
    +   'color:#7a7a7a;font-size:13px;text-decoration:underline;cursor:pointer;font-family:inherit}'
    + '.phcx__no:hover{color:#bbb}'
    + '.phcx__x{position:absolute;top:10px;right:12px;z-index:2;width:34px;height:34px;border:0;'
    +   'border-radius:50%;background:rgba(0,0,0,.5);color:#fff;font-size:21px;line-height:1;'
    +   'cursor:pointer;transition:background .15s ease}'
    + '.phcx__x:hover{background:rgba(0,0,0,.85)}'
    + '.phcx__x:focus-visible,.phcx__cta:focus-visible,.phcx__alt:focus-visible,'
    +   '.phcx__no:focus-visible{outline:2px solid #d61f26;outline-offset:2px}'
    + '.phcx__sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;'
    +   'clip:rect(0 0 0 0);white-space:nowrap;border:0}'
    + '@media (max-width:600px){'
    +   '.phcx{padding:12px}'
    +   '.phcx__body{padding:22px 18px 24px}'
    +   '.phcx__head{padding:24px 18px 2px}'
    +   '.phcx__mark{font-size:30px;letter-spacing:.14em;text-indent:.14em}'
    +   '.phcx__clock{gap:6px}'
    +   '.phcx__num{font-size:24px}'
    +   '.phcx__unit{padding:10px 2px}'
    + '}'
    + '@media (prefers-reduced-motion:reduce){.phcx,.phcx__card{transition:none}}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* --------------------------------------------------------------- markup */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function parts() {
    var ms = Math.max(0, LAUNCH_AT - Date.now());
    var s  = Math.floor(ms / 1000);
    return {
      d: Math.floor(s / 86400),
      h: Math.floor(s / 3600) % 24,
      m: Math.floor(s / 60) % 60,
      s: s % 60
    };
  }

  function unit(id, label) {
    return '<div class="phcx__unit"><div class="phcx__num" id="' + id + '">--</div>'
         + '<div class="phcx__lbl">' + label + '</div></div>';
  }

  var wrap = document.createElement('div');
  wrap.className = 'phcx';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-labelledby', 'phcx-title');
  wrap.innerHTML = ''
    + '<div class="phcx__card">'
    +   '<button class="phcx__x" type="button" aria-label="Close">&times;</button>'
    +   '<div class="phcx__head">'
    +     '<p class="phcx__mark">CHIMERA</p>'
    +     '<p class="phcx__sub">Wireless Pass-Thru</p>'
    +   '</div>'
    +   '<div class="phcx__body">'
    +     '<p class="phcx__eyebrow">Arriving 16 October</p>'
    +     '<h2 class="phcx__sr" id="phcx-title">Chimera launches 16 October 2026</h2>'
    +     '<p class="phcx__copy">Wireless Bluetooth tuning for your Power Stroke. Read, tune and '
    +       'flash your ECM or FICM from your phone &mdash; no laptop, no cables across the dash.</p>'
    +     '<div class="phcx__clock" aria-hidden="true">'
    +       unit('phcx-d', 'Days') + unit('phcx-h', 'Hours')
    +       unit('phcx-m', 'Mins') + unit('phcx-s', 'Secs')
    +     '</div>'
    +     '<p class="phcx__date">Launching Friday, 16 October 2026</p>'
    +     '<a class="phcx__cta" href="' + LEARN_LINK + '">See What Chimera Does</a>'
    +     '<a class="phcx__alt" href="' + NOTIFY_LINK + '">Get launch-day alerts</a>'
    +     '<button class="phcx__no" type="button">Maybe later</button>'
    +   '</div>'
    + '</div>';

  /* ------------------------------------------------------------ behaviour */
  var timer = null, lastFocus = null, bodyOverflow = '';

  function tick() {
    var p = parts();
    var map = { 'phcx-d': String(p.d), 'phcx-h': pad(p.h), 'phcx-m': pad(p.m), 'phcx-s': pad(p.s) };
    for (var id in map) {
      var el = document.getElementById(id);
      if (el && el.textContent !== map[id]) { el.textContent = map[id]; }
    }
    if (LAUNCH_AT - Date.now() <= 0) { close(); }   // hit zero while open
  }

  function close() {
    snooze();
    if (timer) { window.clearInterval(timer); timer = null; }
    wrap.classList.remove('is-open');
    document.body.style.overflow = bodyOverflow;
    document.removeEventListener('keydown', onKey, true);
    window.setTimeout(function () {
      if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }, 250);
  }

  function onKey(ev) {
    if (ev.key === 'Escape' || ev.keyCode === 27) { close(); return; }
    if (ev.key !== 'Tab') { return; }
    var f = wrap.querySelectorAll('button, a[href]');
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  }

  function open() {
    if (Date.now() >= LAUNCH_AT || Date.now() < snoozedUntil()) { return; }
    lastFocus = document.activeElement;
    document.body.appendChild(wrap);

    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    tick();
    timer = window.setInterval(tick, 1000);

    wrap.querySelector('.phcx__x').addEventListener('click', close);
    wrap.querySelector('.phcx__no').addEventListener('click', close);
    // Following a link counts as engagement — snooze so it doesn't reappear
    // on the very next page load.
    wrap.querySelector('.phcx__cta').addEventListener('click', snooze);
    wrap.querySelector('.phcx__alt').addEventListener('click', snooze);
    wrap.addEventListener('click', function (ev) {
      if (ev.target === wrap) { close(); }
    });
    document.addEventListener('keydown', onKey, true);

    window.requestAnimationFrame(function () {
      wrap.classList.add('is-open');
      var x = wrap.querySelector('.phcx__x');
      if (x) { x.focus(); }
    });
  }

  window.setTimeout(open, DELAY_MS);
})();
